module.exports = __webpack_public_path__ + "static/media/Hang Tough Foundation Logo.610a8549.jpeg";